module.exports = __webpack_public_path__ + "static/img/gas-mask_256.d174e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gas-mask_256.png
// module id = rhFw
// module chunks = 0